import type {
  ImageProps as ExpoImageProps,
  ImageErrorEventData,
} from "expo-image";
// eslint-disable-next-line no-restricted-imports
import { Image as ExpoImage } from "expo-image";
import { useState } from "react";
import { View, type ImageSourcePropType } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import useLogo from "$src/core/hooks/use-logo";

import $ from "./Image.styles";

const UniExpoImage = withUnistyles(ExpoImage);

const hasSource = (
  source: ExpoImageProps["source"],
): source is ImageSourcePropType => {
  const sources = Array.isArray(source) ? source : [source];
  return sources.some(
    (_source) =>
      typeof _source === "string" ||
      (!!_source &&
        typeof _source === "object" &&
        "uri" in _source &&
        !!_source.uri),
  );
};
const Image = ({
  source,
  style,
  transition = 150,
  contentFit,
  contentPosition,
  onError,
  cachePolicy = "memory-disk",
  priority = "normal",
  loading,
  ...restProps
}: ExpoImageProps) => {
  const logo = useLogo();

  const [error, setError] = useState(false);

  const handleError = (e: ImageErrorEventData) => {
    if (e.error) {
      onError?.(e);
      setError(true);
    }
  };

  if (!hasSource(source) || error) {
    return (
      <View style={[style, $.fallbackContainer]}>
        <UniExpoImage
          source={logo}
          style={$.fallbackImage}
          transition={transition}
          contentFit="contain"
          contentPosition="center"
          cachePolicy={cachePolicy}
          priority={priority}
          loading={loading}
          {...restProps}
        />
      </View>
    );
  }

  return (
    <UniExpoImage
      source={source}
      style={style}
      transition={transition}
      contentFit={contentFit}
      contentPosition={contentPosition}
      onError={handleError}
      cachePolicy={cachePolicy}
      priority={priority}
      loading={loading}
      {...restProps}
    />
  );
};

export default Image;
